
//AuthContext.js

import React, { createContext, useState, useContext } from 'react';

export const AuthContext = createContext();

function AuthProvider({ children }) {
  const [auth, setAuth] = useState(false);
  const [user, setUser] = useState(null);
//  const [username, setUsername] = useState('');
//  const [name, setName] = useState('');
//  const [role, setRole] = useState('');


  return (
    <AuthContext.Provider value={{ auth, setAuth, user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);


export default AuthProvider;